// @generated by protoc-gen-connect-es v1.1.3 with parameter "target=ts+js+dts,import_extension=.mjs"
// @generated from file myplace/api/myplace.proto (package nautilus.myplace.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetBootstrapConfigReply, GetBootstrapConfigRequest, GetGameReply, GetGameRequest, ListBasesReply, ListBasesRequest, ListCustomerServicesReply, ListCustomerServicesRequest, ListEventsReply, ListEventsRequest, ListGamesReply, ListGamesRequest, ListJackpotsReply, ListJackpotsRequest, ListPopupsReply, ListPopupsRequest } from "./myplace_pb.mjs";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service nautilus.myplace.v1.MyPlace
 */
export const MyPlace = {
  typeName: "nautilus.myplace.v1.MyPlace",
  methods: {
    /**
     * @generated from rpc nautilus.myplace.v1.MyPlace.GetGame
     */
    getGame: {
      name: "GetGame",
      I: GetGameRequest,
      O: GetGameReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc nautilus.myplace.v1.MyPlace.ListGames
     */
    listGames: {
      name: "ListGames",
      I: ListGamesRequest,
      O: ListGamesReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc nautilus.myplace.v1.MyPlace.ListJackpots
     */
    listJackpots: {
      name: "ListJackpots",
      I: ListJackpotsRequest,
      O: ListJackpotsReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc nautilus.myplace.v1.MyPlace.ListEvents
     */
    listEvents: {
      name: "ListEvents",
      I: ListEventsRequest,
      O: ListEventsReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc nautilus.myplace.v1.MyPlace.ListPopups
     */
    listPopups: {
      name: "ListPopups",
      I: ListPopupsRequest,
      O: ListPopupsReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc nautilus.myplace.v1.MyPlace.ListCustomerServices
     */
    listCustomerServices: {
      name: "ListCustomerServices",
      I: ListCustomerServicesRequest,
      O: ListCustomerServicesReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc nautilus.myplace.v1.MyPlace.ListBases
     */
    listBases: {
      name: "ListBases",
      I: ListBasesRequest,
      O: ListBasesReply,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc nautilus.myplace.v1.MyPlace.GetBootstrapConfig
     */
    getBootstrapConfig: {
      name: "GetBootstrapConfig",
      I: GetBootstrapConfigRequest,
      O: GetBootstrapConfigReply,
      kind: MethodKind.Unary,
    },
  }
};

